import CampaignSegmentationDirective from './CampaignSegmentationDirective';
import 'edge/platform/campaign/module';

export default angular.module('edge.platform.segmentation.campaign', ['edge.platform.campaign']).directive('gwCampaignSegmentation', CampaignSegmentationDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/campaign/module.js
// module id = 1066
// module chunks = 0